import React from 'react';

export const OtherBusServicesView = (content_links=[]) => {
    let li_view = []
    let ui_view = []
    if (content_links && content_links.length) {
        content_links.forEach((x, i) => {
            li_view.push(
                <li key={i} onClick={() => {
                }}>
                    <a href={x.slug ? `${__ENV_CONFIG__.__GOIBIBO__}${x.slug}` : ''} title={x.name}>{x.name}</a>
                </li>
            )
        })
    }
    if (li_view && li_view.length) {
        ui_view.push(<ul className="makeColumn" key="other_bus_services">{li_view}</ul>)
    }
    return { view: ui_view, isDataPresent: !!ui_view.length}
}

export const getNearCitiesView = (data) => {
    let view = []
    let liView = []
    if (data && data.links && data.links.length) {
        for (let i in data.links) {
            const { city_name, slug } = data.links[i];
            liView.push(
                <li key={city_name + slug + i}>
                    <a href={slug ? `${__ENV_CONFIG__.__GOIBIBO__}${slug}` : ''}>{city_name}</a>
                </li>
            )
        }
        if (liView && liView.length) {
            view.push(<ul key="nearCityView">{liView}</ul>)
        }
    }
    return { view, isDataPresent: !!view.length }
}


export const getRouteOperatorView = (data) => {
    let view = []
    let liView = []
    if (data && data.links && data.links.length) {
        for (let i in data.links) {
            const { src, dest, slug, op_name } = data.links[i];
            liView.push(
                <li key={src + dest + i}>
                    <a href={slug ? `${__ENV_CONFIG__.__GOIBIBO__}${slug}` : ''}>{`${src} to ${dest} Bus`}</a>
                </li>
            )
        }
        if (liView && liView.length) {
            view.push(<ul key="routeOperatorView">{liView}</ul>)
        }
    }
    return { view, isDataPresent: view.length ? true : false }
}


export const getPointsView = (data) => {
    let view = []
    let liView = []
    if (data && data.length) {
        for (let i in data) {

            liView.push(
                <li key={data[i] + i}>
                    <span title={data[i]}>{data[i]}</span>
                </li>
            )
        }
        if (liView && liView.length) {
            view.push(<ul className="makeColumn" key="pointsView">{liView}</ul>)
        }
    }
    return { view, isDataPresent: !!view.length }
}

export const getOtherOperatorView = (data) => {
    let view = []
    let liView = []
    if (data && data.length) {
        for (let i in data) {
            const { slug, n, id } = data[i];
            liView.push(
                <li key={id + n + slug + i} onClick={() => {
                }}>
                    <a href={slug || ''} title={n}>{n}</a></li>
            )
        }
        if (liView && liView.length) {
            view.push(<ul className="makeColumn" key="otherOperatorView">{liView}</ul>)
        }
    }
    return { view, isDataPresent: !!view.length }
}

export const getOperatorView = (data) => {
    let view = []
    let liView = []
    if (data && data.length) {
        for (let i in data) {
            const { from_city, to_city } = data[i];
            liView.push(
                <li key={data[i].link + from_city + to_city} onClick={() => {
                }}>
                    <a href={data[i].link} title={data[i].name}>{`${from_city} to ${to_city} Bus`}</a></li>
            )
        }
        if (liView && liView.length) {
            view.push(<ul className="makeColumn" key="operatorsView">{liView}</ul>)
        }
    }
    return { view, isDataPresent: !!view.length }
}
